import React, { useContext } from "react";
import ThemeContext from "../../ThemeProvider/ThemeContext";
import { CarinaContext } from "../../CarinaProvider";
export var useContentDelay = function(animationFunction) {
    var ref;
    var prefersReducedMotion = ((ref = useContext(CarinaContext)) !== null && ref !== void 0 ? ref : {
        prefersReducedMotion: false
    }).prefersReducedMotion;
    var ref1 = useContext(ThemeContext), duration = ref1.animation.duration;
    if (prefersReducedMotion) {
        return 'unset';
    }
    return animationFunction === 'productive' ? duration[200] : duration[400];
};
export default useContentDelay;
